export default __webpack_public_path__ + "static/media/P15.6a7bd20b.png";